import React, { useEffect, useState } from 'react';
import DataTable from "react-data-table-component";
import axios from 'axios';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import { FiEdit3, FiTrash2 } from "react-icons/fi";
import FadeLoader from "react-spinners/FadeLoader";
import { FcCancel } from "react-icons/fc";
import StatusDropdown from '../MyWorklist/StatusDropdown'
import { BiSortAlt2 } from "react-icons/bi";
import Popover from '@mui/material/Popover';
import { fetchParkinglotDetailsbyentityid } from '../../Services/parkinglotService'
import OwnerPropertyImage from '../../Images/Frame.jpg';
import ValidationMessages from "../utils/validationMessages";
import SelectPricingPlan from '../Settings/SelectPricingPlan';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";


const OwnerParkinglotRegistration = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);  // State to track anchor element for the popup
    const [selectedRowData, setSelectedRowData] = useState(null);
    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
    const [parkingLotBookingDetails, setParkingLotBookingDetails] = useState([]);
    const [filter, setFilter] = useState([]);
    const [search] = useState("");
    const [,setPopupVisible] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [rowData, setRowData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [updateData, setUpdateData] = useState(false);

    const [selectedStatus, setSelectedStatus] = useState(''); // This will store the selected status
    const [sortDirection, setSortDirection] = useState('asc'); // State for sorting direction
    const stateLogedInUser = props.entityId;
    const [isSelectPricingOpen, setIsSelectPricingOpen] = useState(false);
    const fetchParkinglotdetails = async () => {
        setLoader(true);  // Show loader before fetching data
        try {
            const parkingDetails = await fetchParkinglotDetailsbyentityid(stateLogedInUser);
            setParkingLotBookingDetails(parkingDetails);  // Set fetched data

        } catch (error) {
            console.error("Error fetching parking lot details:", error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchParkinglotdetails();
    }, [updateData]);
    useEffect(() => {
        let result = parkingLotBookingDetails;

        // Filter by search query
        if (search) {
            result = result.filter((item) => {
                return (item.parkingLotAddress || item.createdDate).toLowerCase().includes(search.toLowerCase());
            });
        }

        // Filter by selected status
        if (selectedStatus.length > 0) {
            result = result.filter((item) => selectedStatus.includes(item.status));
        }

        setFilter(result);
    }, [search, parkingLotBookingDetails, selectedStatus]);
    const handleDelete = (val, typeOfButton) => {
        let message;
        let message2;
        let status;
        if (typeOfButton === 'trash') {
            message = ValidationMessages.actionIrreversible;
            message2 = ValidationMessages.proceed
            status = 'delete';
        } else if (typeOfButton === 'cancel') {
            message = ValidationMessages.propInactive;
            message2 = ValidationMessages.makeActive
            status = val.status === 'Active' ? 'Inactive' : 'Active'
        }
        else if (typeOfButton === 'active') {
            message = ValidationMessages.propActive;
            message2 = ValidationMessages.confirmContinue
            status = val.status === 'Inactive' ? 'Active' : 'Inactive'
        }

        let data = { EmailId: val.emailId, Parking_Lot_ID: val.parking_Lot_ID, message, message2, status, val };
        setRowData(data);
        setOpen(true);
        setPopupVisible(false);
    };
    const handleConfirm = (text, status, val) => {
        if (text === 'confirm') {
            if (status === 'delete') {
                setLoader(true)
                const requestOptions = {
                    method: 'POST',
                    headers: { "x-functions-key": hostHeader },
                    body: JSON.stringify(rowData)
                };
                axios.post(`${hostPath}/api/DeleteParkingLotDetailsByEmailId`, requestOptions.body, { headers: requestOptions.headers })
                    .then(response => {
                        if (response.data) {
                            if (response.data.status) {
                                const newdata = parkingLotBookingDetails.filter((item) => item.parking_Lot_ID !== rowData.Parking_Lot_ID);
                                setParkingLotBookingDetails(newdata);
                                setFilter(newdata);
                                setOpen(false);
                            }
                            else {
                                alert(response.data.responseMessage);
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    }).finally(() => {
                        // setLoader(false)
                        setUpdateData(!updateData);

                    })
            }
            else if (status === 'Inactive' || status === 'Active') {
                setLoader(true)
                const CoardinateDetails = val?.coardinateDetails;
                const Scheduleavailability = val?.scheduleavailability
                const parkinglot = {
                    "EmailId": val?.emailId,
                    "EmpId": val?.empId,
                    "NickName": val?.nickName,
                    "EntityRegistrationID": val?.entityRegistrationID,
                    "ParkingLotAddress": val?.parkingLotAddress,
                    "Parking_Lot_ID": val?.parking_Lot_ID,
                    "id": val?.id,
                    "CreatedDate": val?.createdDate,
                    "Status": status,
                    "Comment": val?.comment,
                    "StreetName": val?.streetName,
                    "BankDetailID": val?.bankDetailID,
                    CoardinateDetails,
                    Scheduleavailability
                };
                axios.post(`${hostPath}/api/UpdateParkingLotDetails`, parkinglot, {
                    headers: {
                        "x-functions-key": hostHeader
                    }
                })
                    .then(response => {
                        if (response.data) {
                            setOpen(false);
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    }).finally(() => {
                        // setLoader(false)
                        setUpdateData(!updateData);
                    })
                    ;
            }
        }
        else if (text === 'cancel') {
            setOpen(false);
        }
    };

    const handleEdit = (e, val) => {
        setSelectedRowData(val);
        setAnchorEl(e.currentTarget);  // Set the clicked element as the anchor for the popup
    };

const handleEdittomap = (val) => {
  console.log("valTest", val);

  props.onSetParkingLotObj(val);
  props.onSetDefaultAddress(val?.parkingLotAddress);

  /* ----------------------------------------------------
     🔹 BUILD GROUP → NORMALIZED SCHEDULE MAP
  ---------------------------------------------------- */
  const groupScheduleMap = {};

  (val?.groupSchedules || []).forEach((group) => {
    const groupName = group.groupName || "Default";

    groupScheduleMap[groupName] = (group.schedules || []).map((sch) => ({
      id: sch.id,
      title: sch.title,
      allDay: sch.allDay || false,
      recurrence: sch.recurrence,
      customRecurrenceCount: sch.customRecurrenceCount || 0,

      // ✅ Normalize dates (VERY IMPORTANT)
      start: sch.start ? new Date(sch.start) : null,
      end: sch.end ? new Date(sch.end) : null,
      endType: sch.endType,
      endDateOn: sch.endDateOn ? new Date(sch.endDateOn) : null,
      endAfter: sch.endAfter,
      recurrenceId: sch.recurrenceId || null,

      // ✅ Inject groupName (missing earlier)
      groupName,

      isMaster: sch.isMaster ?? true,
      isActive: sch.isActive ?? true,
    }));
  });

  /* ----------------------------------------------------
     🔹 TRANSFORM PSLs + ATTACH GROUP SCHEDULES
  ---------------------------------------------------- */
  const transformedAreas = (val?.coardinateDetails || []).map((details) => {
    const groupName =
      Array.isArray(details?.groupName)
        ? details.groupName[0]
        : details?.groupName || "Default";

    return {
      Coordinates: {
        Title: details?.title || "PSL - Parking Space Location",
        Latitude: parseFloat(details?.latitude) || 0,
        Longitude: parseFloat(details?.longitude) || 0,
      },
      Name: details?.title || "PSL - Parking Space Location",
      id: parseInt(details?.id, 10) || Date.now(),
      VehicleSpotSize: details?.vechileSpotSize || "",
      pslName: details?.pslName || "",
      groupName,

      latandlong: `Latitude: ${parseFloat(details?.latitude) || 0} Longitude: ${parseFloat(details?.longitude) || 0}`,

      // ✅ FINAL: PSL gets schedules from its GROUP
      // ScheduleAvailability: groupScheduleMap[groupName] || [],
    };
  });

  console.log("transformedAreasTest", transformedAreas);

  props.onSetAreasMarked(transformedAreas);
   props.handleSetEdit(true);
  setPopupVisible(false);
};   

    const handleStatusChange = (selectedStatus) => {
        setSelectedStatus(selectedStatus);
    };
    const handleSort = (column) => {
        // Toggle the sorting direction
        const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
        setSortDirection(newSortDirection);

        // Sort the data based on the 'createdDate' field
        const sortedData = [...filter].sort((a, b) => {
            const dateA = new Date(a[column]);
            const dateB = new Date(b[column]);

            if (newSortDirection === 'asc') {
                return dateA - dateB;
            } else {
                return dateB - dateA;
            }
        });

        setFilter(sortedData);
    };
    const columns = [
        {
            name: "Nickname",
            selector: (row) => row.nickName
        },
        {
            name: "Street Address",
            cell: (row) => (
                <div
                    style={{ cursor: 'pointer' }}  // Style to indicate it's clickable
                    onClick={(e) => handleEdittomap(row)} // Call function when clicked
                >
                    {row.parkingLotAddress}
                </div>
            ),
        },

        {
            name: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                    Parking Spaces Selected
                </div>
            ),
            selector: (row) =>
                row?.coardinateDetails?.filter((coord) => coord.title === "PSL - Parking Space Location").length || 0,
            grow: 1,
            wrap: true,
            center: true, 
            style: { justifyContent: "center", textAlign: "center" }, 
        },

        {
            name: (
                <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleSort('createdDate')}>
                    Created Date <BiSortAlt2 style={{ marginLeft: '5px' }} />
                </div>
            ),
            selector: (row) => row.createdDate,
        },
        {
            name: (
                <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleSort("lastUpdatedDate")}>
                    Last Updated <BiSortAlt2 style={{ marginLeft: '5px' }} />
                </div>
            ),
            selector: (row) => row.lastUpdatedDate,
        },
        {
            name: "Pricing Plan",
            cell: (row) => {
                const plans =
                row.coardinateDetails
                    ?.map((coord) => coord.pricingPlanName)
                    .filter((name) => !!name && name.trim() !== ""); // remove null/empty

                const uniquePlans = [...new Set(plans)]; // remove duplicates

                return (
                <div style={{ cursor: "pointer" }}>
                    {uniquePlans.length > 0 ? uniquePlans.join(", ") : " "}
                </div>
                );
            },
        },


        {
            name: (
                <div style={{ display: 'flex', alignItems: 'start' }}>
                    <StatusDropdown handleStatusChange={handleStatusChange} />
                </div>
            ),
            selector: (row) => row?.status,
        },
        {
            name: "Actions",
            cell: (row) => (

                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '0px' }}>
                    {row.status === 'Inactive' ? (
                        <>
                            {/* Show "Activate" icon for inactive status */}
                            <FiEdit3 title="Activate" aria-label="Activate"
                                style={{
                                    width: "38px",
                                    height: "25px",
                                    padding: "2px 2px",
                                    cursor: "pointer",
                                    justifyContent: "center",
                                    color: "green"
                                }}
                                onClick={() => handleDelete(row, 'active')}  // Change status to Active
                            />
                        </>
                    ) : (
                        <>
                            {/* Show default edit and delete icons for active status */}
                            <FiEdit3 title="Edit" aria-label="Edit"
                                style={{
                                    width: "38px",
                                    height: "25px",
                                    padding: "2px 2px",
                                    cursor: "pointer",
                                    justifyContent: "center",
                                }}
                                onClick={(e) => handleEdit(e, row)} />
                            <FiTrash2 title="Delete" aria-label="Delete"
                                style={{
                                    width: "38px",
                                    height: "25px",
                                    padding: "2px 2px",
                                    cursor: "pointer",
                                    justifyContent: "center",
                                }}
                                onClick={() => handleDelete(row, 'trash')}  // Pass 'trash' as the type
                            />
                            <FcCancel
                                title={row.status === 'Active' ? 'Inactive' : 'Disabled'}
                                aria-label="Inactive"
                                style={{
                                    width: "38px",
                                    height: "25px",
                                    padding: "2px 2px",
                                    cursor: row.status === 'Active' ? "pointer" : "not-allowed",
                                    justifyContent: "center",
                                    opacity: row.status === 'Active' ? 1 : 0.5, // visually show it's disabled
                                }}
                                onClick={row.status === 'Active' ? () => handleDelete(row, 'cancel') : null}
                            />
                        </>
                    )}
                </div>
            ),
        },
    ];

    const tableHeaderStyle = {
        headCells: {
            style: {
                height: "90px",
                fontWeight: 800,
                fontSize: "16px",
                backgroundColor: "white",
                lineHeight: "19.2px",
                fontFamily: "Lato",
                textAlign: "left",
                borderBottom: "none"
            },
        },
    };

    const handleClose = () => {
        setAnchorEl(null);  // Close the popup
    };

    const Isopen = Boolean(anchorEl);  // Boolean to check if the popup is open
    const id = Isopen ? 'edit-popover' : undefined;

    const handleOptionClick = (option) => {
        props.onSetEditOption(option);
        setAnchorEl(null);  // Close the popup after selecting an option
        handleEdittomap(selectedRowData);
        if (option === 'parkingspaces') {
            handleEdittomap(selectedRowData);
        }
    };
    
    const handlePricingPlanClick = () => {
        setIsSelectPricingOpen(true);
        handleClose();
    };

    const handleCancelSelectPricing = (e) => {
        e?.stopPropagation?.();
        setIsSelectPricingOpen(false);
    };

    const handleConfirmSuccess = () => {
        setIsSelectPricingOpen(false);
        setUpdateData(!updateData);
    };   

    const AddProperty = (e) => {
        e.preventDefault();
        props.handleEdit(e, props?.OwnerDetails)
    }
    const pslCount = selectedRowData?.coardinateDetails?.filter(c => c.title === "PSL - Parking Space Location").length || 0;

    const defaultPlanIdForLot =  selectedRowData?.coardinateDetails?.[0]?.pricingPlanID || null;
    return (
        <div>
            {loader && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}
            {parkingLotBookingDetails.length > 0 ? (
                <div>
                    <div className='container-fluid p-0'>
                        {/* Heading with two lines */}
                        <div className="lotmanagement">
                            <div style={{ textAlign: 'center', position: 'relative', top: '-35px' }}>
                                <hr style={{
                                    border: 'none', borderTop: '1px solid #000', margin: '0 20px',
                                    width: '80%', padding: '0 15%', margin: '0 auto',
                                }} />
                                <h3 style={{
                                    display: 'inline-block',
                                    position: 'relative',
                                    backgroundColor: '#fff',
                                    padding: '0 10px',
                                    top: '-12px',  // Move the heading slightly up
                                    fontSize: '18px',
                                    fontWeight: '600'
                                }}>
                                    Properties
                                </h3>
                            </div>
                            <React.Fragment>
                            <div className="table-container">
                            <DataTable
                             columns={columns}
                             data={filter.length ? filter : []}
                             pagination
                             highlightOnHover
                             expandableRows
                             expandableRowsComponent={({ data }) => <ExpandedGroups data={data} />}
                             expandableIcon={{
                               collapsed: (
                                 <div
                                   style={{
                                     display: "flex",
                                     alignItems: "center",
                                     justifyContent: "center",
                                     width: "40px",
                                     height: "30px",
                                     cursor: "pointer",
                                   }}
                                 >
                                   <ExpandMoreIcon style={{ fontSize: "20px", color: "#444" }} />
                                 </div>
                               ),
                               expanded: (
                                 <div
                                   style={{
                                     display: "flex",
                                     alignItems: "center",
                                     justifyContent: "center",
                                     width: "40px",
                                     height: "30px",
                                     cursor: "pointer",
                                   }}
                                 >
                                   <ExpandLessIcon style={{ fontSize: "20px", color: "#444" }} />
                                 </div>
                               ),
                             }}
                             customStyles={{
                               table: {
                                 style: {
                                   border: "1px solid #e0e0e0",
                                   borderRadius: "8px",
                                   overflow: "hidden",
                                   boxShadow: "0px 1px 3px rgba(0,0,0,0.05)",
                                 },
                               },
                               headCells: {
                                 style: {
                                   backgroundColor: "#f8f8f8",
                                   fontWeight: "700",
                                   fontSize: "15px",
                                   borderBottom: "2px solid #e0e0e0",
                                 },
                               },
                               rows: {
                                 style: {
                                   backgroundColor: "#fff",
                                   borderBottom: "1px solid #e0e0e0",
                                   minHeight: "60px",
                                   transition: "all 0.2s ease",
                                 },
                                 highlightOnHoverStyle: {
                                   backgroundColor: "#fafafa",
                                   borderBottomColor: "#ddd",
                                   outline: "none",
                                 },
                               },
                               cells: {
                                 style: {
                                   fontSize: "14px",
                                   color: "#333",
                                   padding: "10px 14px",
                                 },
                               },
                               expanderCell: {
                                 style: {
                                   backgroundColor: "transparent !important", 
                                   boxShadow: "none",
                                   border: "none",
                                   paddingLeft: "6px",
                                   paddingRight: "6px",
                                 },
                               },
                               expanderButton: {
                                 style: {
                                   backgroundColor: "transparent !important", 
                                   color: "#444",
                                   boxShadow: "none",
                                 },
                               },
                               expanderRow: {
                                 style: {
                                   backgroundColor: "transparent !important", 
                                 },
                               },
                             }}
                             noDataComponent={<div style={{ padding: 20 }}>No records found</div>}
                           />                 
                            </div>
                            </React.Fragment>
                        </div>
                    </div>
                    <Dialog
                        classes={{ paper: 'custom-paper-class-delete' }}
                        aria-labelledby="customized-dialog-title"
                        dividers
                        open={open}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <DialogTitle dividers sx={{ textAlign: 'start', color: "#000;", fontSize: "24px", fontWeight: "700", padding: "5px 24px " }} id="customized-dialog-title">
                            {rowData?.message}  {/* Display different messages based on the button clicked */}
                        </DialogTitle>
                        <DialogContent style={{ border: "none", padding: "5px 22px", color: "#000;" }}>
                            <Typography gutterBottom>
                                <span>{rowData?.message2}</span>
                            </Typography>
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: 'right' }}>
                            <Button
                                className='custom-button-cancel'
                                onClick={() => handleConfirm('cancel')}
                            >
                                Cancel
                            </Button>
                            <Button
                                className='custom-button-delete'
                                onClick={() => handleConfirm('confirm', rowData?.status, rowData?.val)}
                            >
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Popover
                        id={id}
                        open={Isopen}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'left',  // Popup will appear to the left of the clicked icon
                            height: '500px',
                            width: '500px'
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'right',  // Popup will align to the right side of the anchor element
                        }}
                    >
                        <div style={{ padding: '10px' }}> {/* Additional padding for content */}
                            <Button
                                variant="text"
                                onClick={() => handleOptionClick('parkingspaces')}
                                style={{ display: 'block', textAlign: 'left', width: '100%', textTransform: 'none' }} // Ensure alignment
                            >
                                Parking Spaces
                            </Button>
                            <Button
                                variant="text"
                                onClick={() => handleOptionClick('parkingschedule')}
                                disabled={pslCount === 0}
                                style={{ display: 'block', textAlign: 'left', width: '100%', textTransform: 'none' }} // Ensure alignment
                            >
                                Parking Schedule
                            </Button>
                            <Button
                                variant="text"
                                onClick={() => handleOptionClick('bankdetails')}
                                disabled={pslCount === 0}
                                style={{ display: 'block', textAlign: 'left', width: '100%', textTransform: 'none' }} // Ensure alignment
                            >
                                Bank Details
                            </Button>
                            <Button
                                variant="text"
                                onClick={handlePricingPlanClick}
                                disabled={pslCount === 0}
                                style={{ display: 'block', textAlign: 'left', width: '100%', textTransform: 'none' }}
                            >
                                Pricing Plan
                            </Button>
                        </div>
                    </Popover>
                    {isSelectPricingOpen && (
                            <div className="popup-overlay" onClick={(e) => e.stopPropagation()}>
                                <div className="popup-content">
                                    <SelectPricingPlan
                                        entityId={stateLogedInUser}
                                        parkingLotId={selectedRowData?.parking_Lot_ID}
                                        currentPlanId={defaultPlanIdForLot}
                                        setIsSelectPricingOpen={setIsSelectPricingOpen}
                                        handleCancelSelectPricing={handleCancelSelectPricing}
                                        onConfirmSuccess={handleConfirmSuccess}
                                    />
                                </div>
                            </div>
                        )}
                </div>)
                : (
                    <div className="no-property-container">
                        <img src={OwnerPropertyImage} alt="No properties registered" className="building-image" />
                        <p className="no-property-text">
                            No property registered yet! Click{' '}
                            <a href="" className="register-link" onClick={AddProperty}>Register New Property</a>{' '}
                            to get started and add your first property.
                        </p>
                    </div>
                )}
        </div>
    );
};

/* ✅ ADD THIS COMPONENT BELOW THE MAIN FUNCTION */

const ExpandedGroups = ({ data }) => {
  const grouped = {};
  data?.coardinateDetails?.forEach((coord) => {
    if (coord.title === "PSL - Parking Space Location") {
      const group = coord.groupName || "Default";
      if (!grouped[group]) grouped[group] = [];
      grouped[group].push(coord);
    }
  });

  const [openMain, setOpenMain] = useState(false);
  const [openGroups, setOpenGroups] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPSL, setSelectedPSL] = useState(null);
  const [isSelectPricingOpen, setIsSelectPricingOpen] = useState(false);

  const toggleMain = () => setOpenMain((prev) => !prev);
  const toggleGroup = (group) =>
    setOpenGroups((prev) => ({ ...prev, [group]: !prev[group] }));

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const openPopover = Boolean(anchorEl);

  const handlePricingPlanClick = () => {
    setIsSelectPricingOpen(true);
    handleClosePopover();
  };

  const handleCancelSelectPricing = (e) => {
    e?.stopPropagation?.();
    setIsSelectPricingOpen(false);
  };

const handleConfirmSuccess = (updatedPlan, selectedPSL) => {
  setIsSelectPricingOpen(false);

  // ✅ Update only group PSLs or one PSL
  if (selectedPSL?.type === "group") {
    // Update only PSLs in the chosen group
    Object.entries(grouped).forEach(([groupName, psls]) => {
      if (groupName === selectedPSL.name) {
        psls.forEach((p) => {
          p.pricingPlanName = updatedPlan?.planName;
          p.pricingPlanID = updatedPlan?.planId;
        });
      }
    });
  } else {
    // Update only that PSL
    Object.entries(grouped).forEach(([groupName, psls]) => {
      psls.forEach((p) => {
        if (p.id === selectedPSL?.id) {
          p.pricingPlanName = updatedPlan?.planName;
          p.pricingPlanID = updatedPlan?.planId;
        }
      });
    });
  }

  // Trigger re-render
  setAnchorEl(null);
};

  if (Object.keys(grouped).length === 0) {
    return (
      <div style={{ padding: "10px 20px", color: "#555" }}>
        No groups available.
      </div>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "#fafafa",
        borderTop: "1px solid #e0e0e0",
        padding: "10px 15px",
      }}
    >
      {/* Main Expandable Header */}
      <div
        onClick={toggleMain}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          fontWeight: 600,
          fontSize: "15px",
          color: "#333",
          backgroundColor: "#f6f6f6",
          border: "1px solid #ddd",
          borderRadius: "5px",
          padding: "10px 12px",
          width: "98%",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {openMain ? (
            <ExpandLessIcon style={{ fontSize: "18px", color: "#444" }} />
          ) : (
            <ExpandMoreIcon style={{ fontSize: "18px", color: "#444" }} />
          )}
          <span>Groups under the above Property</span>
          {/* <span style={{ color: "#007bff" }}>Groups under the above Property</span> */}
        </div>
      </div>

      {/* Expandable Content */}
      {openMain && (
        <div
          style={{
            marginTop: "10px",
            marginLeft: "10px",
            width: "97%",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          {Object.entries(grouped).map(([groupName, psls]) => {
            const isOpen = openGroups[groupName];
            return (
              <div
                key={groupName}
                style={{
                  marginBottom: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "5px",
                  overflow: "hidden",
                  backgroundColor: "#fff",
                  width: "100%",
                }}
              >
                {/* Group Header */}
                <div
                  onClick={() => toggleGroup(groupName)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                    padding: "10px 15px",
                    backgroundColor: "#f9f9f9",
                    borderBottom: isOpen ? "1px solid #ddd" : "none",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    {isOpen ? (
                      <ExpandLessIcon
                        style={{ fontSize: "18px", color: "#444" }}
                      />
                    ) : (
                      <ExpandMoreIcon
                        style={{ fontSize: "18px", color: "#444" }}
                      />
                    )}
                    <span
                      style={{
                        fontWeight: 600,
                        fontSize: "15px",
                        color: "#333",
                      }}
                    >
                      {groupName}
                    </span>
                    <span
                      style={{
                        color: "#666",
                        fontSize: "13px",
                        fontWeight: 400,
                      }}
                    >
                      ({psls.length})
                    </span>
                  </div>
                </div>
                {/* PSL Table */}
                {isOpen && (
                  <div
                    style={{
                      padding: "10px 15px 12px 15px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "14px",
                        color: "#333",
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            backgroundColor: "#f7f7f7",
                            borderBottom: "2px solid #ddd",
                            fontWeight: 600,
                          }}
                        >
                          <th style={{ textAlign: "center", padding: "10px" }}>PSL Name</th>
                          <th style={{ textAlign: "center", padding: "10px" }}>
                            Street Address
                          </th>
                          <th style={{ textAlign: "center", padding: "10px" }}>Created</th>
                          <th style={{ textAlign: "center", padding: "10px" }}>
                            Last Updated
                          </th>
                          <th style={{ textAlign: "center", padding: "10px" }}>
                            Pricing Plan
                          </th>
                        </tr>
                      </thead>
                
                      <tbody>
                        {psls.map((psl, idx) => (
                          <tr
                            key={idx}
                            style={{
                              borderBottom: "1px solid #f2f2f2",
                              backgroundColor: idx % 2 === 0 ? "#fff" : "#fafafa",
                            }}
                          >
                            <td style={{ textAlign: "center", padding: "8px" }}>
                              {psl.pslName || `PSL ${idx + 1}`}
                            </td>
                            <td style={{ textAlign: "center", padding: "8px" }}>
                              {data.parkingLotAddress}
                            </td>
                            <td style={{ textAlign: "center", padding: "8px" }}>
                              {data.createdDate || "-"}
                            </td>
                            <td style={{ textAlign: "center", padding: "8px" }}>
                              {data.lastUpdatedDate || "-"}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "8px",
                                color: "#444",
                                fontWeight: "500",
                              }}
                            >
                              {/* ✅ Show pricing plan name (fallback to “Not Assigned”) */}
                              {psl.pricingPlanName || "Not Assigned"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

              </div>
            );
          })}
        </div>
      )}

      {/* Shared Popover for both Group & PSL edit */}
      <Popover
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: "center", horizontal: "left" }}
        transformOrigin={{ vertical: "center", horizontal: "right" }}
      >
        <div style={{ padding: "10px" }}>
          <Button
            variant="text"
            onClick={handlePricingPlanClick}
            style={{
              display: "block",
              textAlign: "left",
              width: "100%",
              textTransform: "none",
            }}
          >
            Pricing Plan
          </Button>
        </div>
      </Popover>

      {/* Pricing Plan Dialog */}
      {isSelectPricingOpen && (
        <div className="popup-overlay" onClick={(e) => e.stopPropagation()}>
          <div className="popup-content">
            <SelectPricingPlan
  entityId={data?.entityRegistrationID}
  parkingLotId={data?.parking_Lot_ID}
  groupName={selectedPSL?.type === "group" ? selectedPSL?.name : null} // ✅ group context
  pslId={selectedPSL?.type !== "group" ? selectedPSL?.id : null} // ✅ PSL context
  currentPlanId={selectedPSL?.pricingPlanID}
  setIsSelectPricingOpen={setIsSelectPricingOpen}
  handleCancelSelectPricing={handleCancelSelectPricing}
  onConfirmSuccess={(updatedPlan) =>
    handleConfirmSuccess(updatedPlan, selectedPSL)
  }
/>

          </div>
        </div>
      )}
    </div>
  );
};

export default OwnerParkinglotRegistration;
